import { render, staticRenderFns } from "./EventsComponent.vue?vue&type=template&id=652e7faa&"
import script from "./EventsComponent.vue?vue&type=script&lang=ts&"
export * from "./EventsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports